

export default function FooterCard6() {
  return (<>
    <footer className="footer-fc-6">
      <div className="footer-fc-6-container">

        {/* Left Section */}
        <div className="footer-fc-6-col">
          <h2 className="footer-fc-6-logo">HEALTH CARE</h2>
          <p className="footer-fc-6-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
          </p>
        </div>

        {/* Address Section */}
        <div className="footer-fc-6-col center">
          <h3 className="footer-fc-6-heading">Address Info</h3>
          <div className="footer-fc-6-line" />

          <p className="footer-fc-6-text">+1 123 456 789</p>
          <p className="footer-fc-6-text">help@healthcarepro.com</p>
          <p className="footer-fc-6-text">55, dummy street, lane, US</p>
        </div>

        {/* Useful Links */}
        <div className="footer-fc-6-col">
          <h3 className="footer-fc-6-heading">Useful Links</h3>
          <div className="footer-fc-6-line" />

          <ul className="footer-fc-6-links">
            <li>About</li>
            <li>Services</li>
            <li>Doctors</li>
            <li>Appointment</li>
            <li>Pages</li>
            <li>Contact Us</li>
          </ul>

          <h3 className="footer-fc-6-subtitle">Buy Our Best Product</h3>
          <div className="footer-fc-6-line" />
          <button className="buy-btn">Buy Now</button>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-fc-6-bottom">
        <nav className="footer-fc-6-menu">
          <span>Home</span>
          <span>About Us</span>
          <span>Services</span>
          <span>Doctors</span>
          <span>Page</span>
          <span>Blog</span>
          <span>Contact Us</span>
        </nav>

        <p className="footer-fc-6-copy">
          Health Care WordPress Theme 2021 — Designed & Developed by VW Themes
        </p>
      </div>
    </footer>
    <style>{`.footer-fc-6 {margin-top:50px;
  width: 100%;
  background: #1e1e1e;
  color: #ffffff;
  padding: 60px 20px;
  font-family: Arial, sans-serif;
}

.footer-fc-6-container {
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 40px;
}

.footer-fc-6-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.center {
  text-align: center;
}

.footer-fc-6-logo {
  font-size: 28px;
  font-weight: bold;
}

.footer-fc-6-heading {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 6px;
}

.footer-fc-6-subtitle {
  margin-top: 30px;
  font-size: 18px;
  font-weight: 600;
}

.footer-fc-6-line {
  width: 50px;
  height: 2px;
  background: #ffffff40;
  margin: 10px 0;
}

.footer-fc-6-text {
  color: #cccccc;
  font-size: 15px;
  line-height: 1.6;
}

.footer-fc-6-links {
  list-style: none;
  padding: 0;
  margin: 10px 0;
}

.footer-fc-6-links li {
  margin-bottom: 6px;
  color: #cccccc;
  cursor: pointer;
}

.footer-fc-6-links li:hover {
  color: white;
}

.buy-btn {
  background: #08d9e0;
  border: none;
  color: #000;
  padding: 10px 22px;
  border-radius: 25px;
  cursor: pointer;
  font-weight: bold;
}

.buy-btn:hover {
  background: #06c3c8;
}

.footer-fc-6-bottom {
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #ffffff20;
  text-align: center;
}

.footer-fc-6-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  margin-bottom: 15px;
  color: #bbbbbb;
}

.footer-fc-6-menu span {
  cursor: pointer;
}

.footer-fc-6-menu span:hover {
  color: white;
}

.footer-fc-6-copy {
  font-size: 13px;
  color: #888;
}
`}</style></>
  );
}
